import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

export const currentUser = createReducer(null, {
  [types.USER_CURRENT](state, action) {
    return action.user;
  }
});



// WEBPACK FOOTER //
// ./src/reducers/user.js